import axios from 'axios';

export const workflowOneApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/workflow-one`,
    headers: {
        'Content-Type': 'application/json'
    }
})